export enum EOfferRequestsRoute {
  main = '/offer-requests',
  offer = '/offer-requests/:id',
}
